import React, {Fragment} from 'react'
import FloaterDialog from "./Floater/FloaterDialog";

export default class UserInputTextarea extends React.Component
{
	static get defaultProps() 
	{

		var defaultdata = {} ;

		defaultdata.className = 'input-group' ;

	    var v =
    	{
    	} ;

    	return v ;
	}
	  
	constructor(props) 
	{
		super(props);
		
        this.handleInputChange = this.handleInputChange.bind(this, this.props.id);
		this.setDirty = this.setDirty.bind(this) ;
		
		this.keyCount = 0 ;
		
    	// Create a state item here for all items on the form  (Using their id )
		this.state = {
			val: this.props.value, 
			dirty: false,
			valid: this.isValueValid(this.props.value), 
			types: null,
			cursorStart: 0,
			cursorEnd: 0
			};

	}

    sendChangeNotification()
    {
        if ( this.state.dirty == false )
        {
            if ( this.props.onDirty != null )
            {
                // Send a dirty notification if required, and only the first time we change
                this.props.onDirty() ;
            }
        }
    }

    handleInputChange(propertyName, event)
    {
        var isValid = true ;

        if ( event.target != null )
        {
			let cursorStart = event.target.selectionStart;
			let cursorEnd = event.target.selectionEnd;

            if ( this.props.validation.maxlen != null )
            {
                if ( event.target.value.length <= this.props.validation.maxlen )
                {
                    isValid = this.isValueValid(event.target.value) ;

                    this.sendChangeNotification() ;

                    this.setState({ cursorStart: cursorStart, cursorEnd: cursorEnd, val: event.target.value, valid: isValid, dirty: true });
                }
            }
            else
            {
                isValid = this.isValueValid(event.target.value) ;

                this.sendChangeNotification() ;

                this.setState({ cursorStart: cursorStart, cursorEnd: cursorEnd, val: event.target.value, valid: isValid, dirty: true });
            }
        }
    }

	UNSAFE_componentWillMount()
	{
		// This is a callback to tell the parent our ID so it can talk to this contrao
		if ( this.props.parentRef != null )
		{
			this.props.parentRef ( this.props.id, this ) ;		
		}
	}

	componentDidUpdate(prevProps, prevState)
	{
		this.refs.textarea.setSelectionRange(this.state.cursorStart, this.state.cursorEnd) ;
	}
	
    /**
     * Sets the initial 'valid' state and value when the initial props are supplied
     * 
     * @param {props} nextProps - props object passed by React.
     * @return {void} 
     */
	UNSAFE_componentWillReceiveProps(nextProps)
	{
		if ( nextProps.value != this.props.value )
		{
			var isValid = this.isValueValid(nextProps.value) ;
		
			// Set our initial validity state
			this.setState ( { val: nextProps.value, valid: isValid }) ;
		}
	}
	
    /**
     * Returns true if the input value complies with the validation rules supplied
     * 
     * @param {string} param - The value of the string to be tested.
     * @return {bool} true if the test passes.
     */
	isValueValid( param )
	{
		if ( this.props.validation != null )
		{
			if ( this.props.validation.required == true )
			{
				if ( param == null || param == "")
				{
					return false ;
				}
			}		
		}
		
		return true ;
	}
	
	focus()
	{
		if ( this.refs.textarea != null )
		{
			this.refs.textarea.focus() ;
		}
	}
	
    /**
     * Externally callable function to test if the input field is valid
     * 
     * @return {bool} True if the field is valid.
     */
	isValid()
	{		
		return this.isValueValid ( this.state.val ) ;
	}

    /**
     * Externally callable function to test if the input field is valid
     * 
     * @return {bool} True if the field is valid.
     */
	isDirty()
	{		
		return this.state.dirty ;
	}

    /**
     * Externally callable function to test if the input field is valid
     * 
     * @return {bool} True if the field is valid.
     */
	setDirty( value )
	{		
		this.setState ({ dirty: value }) ;
	}

    /**
     * External function to return the value of the input field
     * 
     * @return {string} THe value of the input field.
     */
	getValue()
	{
		return this.state.val ;
	}
	
    /**
     * Generates HTML for the error DIV which wil be visible if the field contents are
     * invalid AND the this.props.displayErrors flag is set. This will generally be set 
     * by the parent form if error display is required.
     * 
     * @param {bool} validFlag - True if this field is currnetly invalid.
     * @return {void} 
     */
	errorDiv ( validFlag )
	{
		var errmsg = "&nbsp;";
		
		if ( this.props.errorText != null )
		{
			if ( this.props.errorText.length != 0)
			{
				errmsg = this.props.errorText ;
			}
		}

		var className = 'input-error-invisible' ;
		
		if ( this.props.displayErrors == true && this.isValid() != true )
		{
			className = 'input-error-visible' ;
		}
		
		return React.createElement ('div', {  htmlFor: this.props.id, key: this.keyCount++, className: className} , errmsg ) ;		
	}
	
	inputCollection ()
	{ 
        var lineList=[];
        
        var v = this.state.val ;
        
        if ( v == null )
    	{
        	v = '';
    	}
        
    	if ( this.props.style != null )
		{
    		var style = this.props.style ;
		}
    	else
    	{
    		var style = {} ;
    	}	

        if ( this.props.className == null )
    	{
        	var className = 'form-control' ;
    	}
        else
    	{
        	var className = this.props.className ;
    	}
        
        if ( this.props.readOnly == 'readonly' || this.props.readonly == true)
    	{
        	style.backgroundColor = 'white' ;
        	style.borderColor = '#ecf3f9' ;
        	style.paddingLeft = '3px';
        	style.color = '#428bcd';
    	}
        
        if ( this.props.displayErrors == true && !this.isValid())
    	{
           	style.borderColor = '#ff0000' ;
    	}

        let val = null ;

        if ( this.props.labelHint !== undefined && this.props.labelHint !== null && this.props.labelHint !== '' )
		{
			val = <Fragment key={'frag' + this.props.id }>
				<label key={'label' + this.props.id} htmlFor={this.props.id} className='col2 col-form-label'>{this.props.label}<FloaterDialog delay={1} iconStyle={{marginTop: '3px'}} key={'float' + this.props.id } text={this.props.labelHint} icon="glyphicon glyphicon-info-sign" color="var(--s360-icon-blue)"/></label>
			</Fragment>
		}
        else
		{
			val = <label key={'label' + this.props.id} htmlFor={this.props.id} className='col2 col-form-label'>{this.props.label}</label>
		}

        lineList.push ( val ) ;

		lineList.push(React.createElement('textarea', {
			key: this.keyCount++,
			className: className,
			style: style,
			ref: 'textarea',
			rows: this.props.rows,
			tabIndex: this.props.tabIndex,
			readOnly: this.props.readOnly,
			type: this.props.text,
			autoFocus: this.props.autoFocus,
			value: v,
			id: this.props.id,
			name: this.props.name,
			placeholder: this.props.placeholder,
			onChange: this.handleInputChange
		}));
        
        if ( this.props.displayErrors == true && !this.isValid())
    	{
            lineList.push ( this.errorDiv(this.isValid()) ) ;    	
    	}
        
        return lineList ;
        
	}
	
	renderedComponent()
	{
    	return React.createElement ('div', {  key: this.props.keyValue }, this.inputCollection());
	}
	
    render() 
    {
    	this.keyCount = 0 ;

    	return this.renderedComponent() ;    	
    }
};
